const config = {
    host_url: process.env.REACT_APP_HOST_URL || 'http://localhost:3000',
    path_prefix: process.env.REACT_APP_PATH_PREFIX || '/',
    maya_payments: {
      url: process.env.REACT_APP_MAYA_PAYMENTS_URL || 'https://pg-sandbox.paymaya.com/payments/v1',
      pub_api_key: process.env.REACT_APP_VAULT_PUBLIC_API_KEY,
      sec_api_key: process.env.REACT_APP_VAULT_SECRET_API_KEY,
    },
    google_pay: {
      environment: (process.env.REACT_APP_GOOGLE_PAY_ENVIRONMENT || 'TEST') as 'TEST' | 'PRODUCTION',
      maya_merchant_id: process.env.REACT_APP_GOOGLE_PAY_MAYA_MERCHANT_ID || 'maya',
      merchant_name: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_NAME || 'Maya Demo App',
      gateway: process.env.REACT_APP_GOOGLE_PAY_GATEWAY || 'mayaph',
      gateway_merchant_id: process.env.REACT_APP_GOOGLE_PAY_GATEWAY_MERCHANT_ID || '',
    },
}

export const googlePayAllowedPaymentMethods: google.payments.api.PaymentMethodSpecification[] = [
    {
        type: 'CARD',
        parameters: {
            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
            allowedCardNetworks: ['AMEX', 'JCB', 'MASTERCARD', 'VISA'],
            billingAddressRequired: true,
            billingAddressParameters: { format: 'FULL', phoneNumberRequired: true },
        },
        tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
                gateway: config.google_pay.gateway,
                gatewayMerchantId: config.google_pay.gateway_merchant_id,
            },
        },
    },
];

export default config
